// extracted by mini-css-extract-plugin
module.exports = {"container":"FQ","disabled":"GQ","bgBlack":"HQ","content":"IQ","countdown":"JQ","topCaption":"KQ","topHeading":"LQ","heading":"MQ","copy":"NQ"};